import React from "react";
import Users from "./Users";
import Kompanite from "./Kompanite";

const SideTab = () => {
  return (
    <>
      <div className="container-fluid">
        <div className="container">
          <div class="d-flex gap-3 align-items-start mt-3">
            <div
              class="nav flex-column nav-pills me-1"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <button
                class="nav-link active"
                id="v-pills-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-home"
                type="button"
                role="tab"
                aria-controls="v-pills-home"
                aria-selected="true"
              >
                Perdoruesit
              </button>
              <button
                class="nav-link"
                id="v-pills-profile-tab"
                data-bs-toggle="pill"
                data-bs-target="#v-pills-profile"
                type="button"
                role="tab"
                aria-controls="v-pills-profile"
                aria-selected="false"
              >
                Kompanite
              </button>
            </div>
            <div class="tab-content" id="v-pills-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-home"
                role="tabpanel"
                aria-labelledby="v-pills-home-tab"
              >
                <Users/>
              </div>
              <div
                class="tab-pane fade"
                id="v-pills-profile"
                role="tabpanel"
                aria-labelledby="v-pills-profile-tab"
              >
                <Kompanite/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideTab;
